/**
 * Mirrors backend `UserProfileMembershipStatusType` (`type_user_profile_membership_status`).
 * Same idea as PROFILE_STAGES: fixed ids aligned with the API, used for client-side checks.
 */
export enum MEMBERSHIP_STATUS_TYPE_ID {
  REJECTED = 1,
  PENDING = 2,
  ACCEPTED = 3,
  ON_HOLD = 4,
  TRIAL = 5,
  INTERESTED = 6,
}

/** Status ids that unlock full product access (accepted, trial). */
export const FULL_ACCESS_MEMBERSHIP_STATUS_IDS: readonly number[] = [
  MEMBERSHIP_STATUS_TYPE_ID.ACCEPTED,
  MEMBERSHIP_STATUS_TYPE_ID.TRIAL,
];

/**
 * Mirrors backend `UserProfileMembershipType` (`type_user_profile_membership`).
 */
export enum MEMBERSHIP_TYPE_ID {
  BASIC = 1,
  MEMBER_BLUE = 2,
  MEMBER_BRONZE = 3,
  MEMBER_SILVER = 4,
  MEMBER_GOLD = 5,
  MEMBER_PLATINUM = 6,
  MEMBER_BLACK = 7,
}
